import type { IconData } from '@stacksjs/iconify-core'

export const contentDeleteFolder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h4l2 2h8v4.875A5.5 5.5 0 0 0 6.59 13H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.265 8.204q.386.13.735.331a4 4 0 1 1-.735-.331M11.06 14l.939-.94l.94.94L14 12.94l-.94-.94l.94-.94L12.94 10l-.94.94l-.94-.94L10 11.06l.94.94l-.94.94z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentDeleteFolder
